import { NavLink } from 'react-router-dom'
import classnames from 'classnames'

import useMerchantStore from 'store/merchant'
import { useCanUI } from 'hooks/useCanUI'

const Tabs = (): JSX.Element => {
  const merchantProfile = useMerchantStore((state) => state.merchantProfile)
  const merchantProfileModStatus = useMerchantStore(
    (state) => state.merchantProfileModStatus
  )
  const { merchantTabsNavigation } = useCanUI()

  if (merchantProfileModStatus !== 'success') return <></>

  return (
    <div className="flex flex-grow">
      <nav className="flex flex-wrap z-1">
        {merchantTabsNavigation.map((item, index) => (
          <NavLink
            key={'profile-' + index}
            className={({ isActive }) =>
              classnames(
                'px-3 py-2 text-gray-700 border-primary ',
                isActive ? 'border-b-2' : null
              )
            }
            // activeClassName="border-b-2"
            to={`/merchant-profile/${merchantProfile[0]?.merchantTraderId}/${item.route.pathname}`}
          >
            <span className="tracking-wider uppercase font-light">
              {item.route.title}
            </span>
          </NavLink>
        ))}
      </nav>
    </div>
  )
}

export default Tabs
